import React, { useEffect, useState } from 'react';
import usePageTitle from 'hooks/usePageTitle';
import { CONTENT_TOP } from 'dashboard/layouts/admin/chromeGeometry';
import { Box, Grid, Stack } from '@mui/material';
import { useOutletContext } from 'react-router';
import { toast } from 'react-toastify';
import { API } from 'utilities/api';
import { LoadingOverlay } from 'dashboard/components/common';
import Delete from 'dashboard/pages/brand/settings/components/Delete';
import Information from 'dashboard/pages/brand/settings/components/Information';
import Profile from 'dashboard/pages/brand/settings/components/Profile';
import Socials from 'dashboard/pages/brand/settings/components/Socials';

export default function BrandSetting() {
  usePageTitle('Brand settings', 'Your name, logo, colours and the details shown to customers.');
  const [selectedBrand] = useOutletContext();
  const [brandData, setBrandData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    if (!selectedBrand) return Promise.resolve();
    setLoading(true);
    return API.getBrandById({ brand_id: selectedBrand })
      .then((res) => setBrandData(res || {}))
      .catch((err) => {
        toast.error(err?.message || err);
        console.log('error fetchData', err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, [selectedBrand]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ pt: CONTENT_TOP }}>
      <Grid container spacing='24px' mb='24px'>
        <Grid item xs={12} lg={6}>
          <Stack direction='column' spacing='24px'>
            <LoadingOverlay loading={loading} minHeight={120}>
              <Profile
                name={brandData?.name}
                logo={brandData?.logo_upload_path}
                domain={brandData?.domain}
              />
            </LoadingOverlay>
            <LoadingOverlay loading={loading} label='Loading brand information…' minHeight={400}>
              <Information initData={brandData} fetchData={fetchData} />
            </LoadingOverlay>
          </Stack>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Stack direction='column' spacing='24px'>
            <LoadingOverlay loading={loading} minHeight={200}>
              <Socials brandData={brandData} />
            </LoadingOverlay>
            <LoadingOverlay loading={loading}>
              <Delete brandData={brandData} />
            </LoadingOverlay>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
